<template>
	<div class="payment-form">
		<LeadLockup lead="Payment">
			All transactions are secure and encrypted.
		</LeadLockup>

		<VSRadioGroup>
			<VSRadio
				id="credit-card-option"
				:model-value="paymentProcessor"
				value="credit-card"
				name="Credit card"
				label="Credit card"
				@change="setPaymentProcessor"
			>
				<template #label-context>
					<PaymentCards />
				</template>
				<div
					v-show="payingWithCreditCard"
					class="payment-form__payment-method-item"
				>
					<Component
						:is="billingComponent"
						ref="billing"
						:gateway="billingGateway"
						:show-postal-code="false"
						:show-privacy-policy="false"
					/>
				</div>
			</VSRadio>

			<VSRadio
				v-if="enablePaypal"
				id="paypal-option"
				:model-value="paymentProcessor"
				value="paypal"
				name="PayPal"
				label="PayPal"
				@change="setPaymentProcessor"
			>
				<template #label-context>
					<PaypalLogo />
				</template>
				<div
					v-show="payingWithPaypal"
					class="payment-form__payment-method-item"
				>
					<VSWell>
						<p>
							After clicking "Pay with PayPal", you will be
							redirected to PayPal to complete your purchase
							securely.
						</p>
					</VSWell>
				</div>
			</VSRadio>
		</VSRadioGroup>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { VSRadioGroup, VSRadio, VSWell } from '@component/UI';
import LeadLockup from '@component/user-backend/Checkout/V4/LeadLockup.vue';
import PaymentCards from '@component/user-backend/Checkout/V4/PaymentCards.vue';
import PaypalLogo from '@component/user-backend/Checkout/V4/PaypalLogo.vue';
import Braintree from '@component/user-backend/Checkout/V4/Braintree.vue';

export default {
	name: 'Payment',

	components: {
		LeadLockup,
		Braintree,
		PaymentCards,
		PaypalLogo,
		VSRadioGroup,
		VSRadio,
		VSWell,
	},

	computed: {
		...mapState('checkout', [
			'billingGateway',
			'billingComponent',
			'paymentProcessor',
		]),
		...mapGetters('checkout', [
			'payingWithCreditCard',
			'enablePaypal',
			'payingWithPaypal',
		]),
	},

	beforeMount() {
		this.setGetToken(() => this.$refs.billing.getToken());
	},

	methods: mapMutations('checkout', ['setGetToken', 'setPaymentProcessor']),
};
</script>

<style lang="scss" scoped>
.payment-form {
	&__payment-method-item {
		padding: var(--size-md);
		display: grid;
		gap: var(--size-md);
	}
}
</style>
